import React, { useEffect, useState } from "react";
import { FaUserCog } from "react-icons/fa";
import { BsFillPieChartFill } from "react-icons/bs";
import { AiOutlineSetting } from "react-icons/ai";
import { BiBlock } from "react-icons/bi";
import styles from "../component/SideBar.module.css";
import Body from "./Body";

const SideBar = () => {
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "Dashboard"
  );

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      <div className={styles.parent_container}>
        <div className={styles.SideBar_parent}>
          {/* <div> */}
          <div className={styles.admin_title_name}>
            <div className={styles.icon_and_name}>
              <span className={styles.hidoc_admin}>
                <FaUserCog size={60} className={styles.user_icon} />
                <p className={styles.admin_child_container}>Hidoc Admin</p>
              </span>
              <p className={styles.admin_name}>Admin</p>
            </div>
          </div>
          {/* </div> */}
          <div className={styles.list_parent}>
            <div className={styles.admin_list}>
              <li
                className={styles.ul_values}
                onClick={() => handleTabClick("Dashboard")}
                style={
                  activeTab === "Dashboard"
                    ? { backgroundColor: "#101d28" }
                    : {}
                }
              >
                <BsFillPieChartFill size={23} />
                Dashboard
              </li>
              <li
                className={styles.ul_values}
                onClick={() => handleTabClick("Settings")}
                style={
                  activeTab === "Settings" ? { backgroundColor: "#101d28" } : {}
                }
              >
                <AiOutlineSetting size={28} />
                Manage specialist
              </li>
              <li
                className={styles.ul_values}
                onClick={() => handleTabClick("Block")}
                style={
                  activeTab === "Block" ? { backgroundColor: "#101d28" } : {}
                }
              >
                <BiBlock size={28} />
                Block Users
              </li>
            </div>
          </div>
        </div>
        <Body activeTab={activeTab} />
      </div>
    </>
  );
};

export default SideBar;
